import { render, staticRenderFns } from "./giris.vue?vue&type=template&id=04fd0dfe&"
import script from "./giris.vue?vue&type=script&lang=js&"
export * from "./giris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "giris.vue"
export default component.exports